"use strict"; // Sh**t! I Smoke
// Copyright (C) 2018-2020  Marcelo S. Coelho, Amaury Martiny

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.raceApiPromise = void 0;

var promise_1 = require("@shootismoke/dataproviders/lib/promise");

var date_fns_1 = require("date-fns");

var p_any_1 = __importDefault(require("p-any"));

var debug_1 = __importDefault(require("debug"));

var secretSauce_1 = require("./secretSauce");

var station_1 = require("./station");

var l = debug_1["default"]('shootismoke:ui:race');
/**
 * We show pm25 results within this number of hours. More than this, we
 * consider the results as inaccurate.
 */

var NORMALIZED_WITHIN_HOURS = 6;
/**
 * Given some normalized data points, and the current GPS, construct an API
 * object with sanitized data.
 *
 * @param normalized - The normalized data to process
 */

function createApi(gps, normalized) {
  var now = new Date();
  var sanitizedNormalized = normalized // From the normalized data, remove the entries that are too old.
  .filter(function (_a) {
    var date = _a.date;
    return Math.abs(date_fns_1.differenceInHours(new Date(date.utc), now)) <= NORMALIZED_WITHIN_HOURS;
  }) // Remove the entries that are negative (happens on openaq).
  .filter(function (_a) {
    var value = _a.value;
    return value >= 0;
  });
  var pm25 = sanitizedNormalized.filter(function (_a) {
    var parameter = _a.parameter;
    return parameter === 'pm25';
  }); // TODO We can sort the pm25 array by closest to `gps`.

  if (pm25.length) {
    return {
      normalized: sanitizedNormalized,
      pm25: pm25[0],
      shootismoke: {
        dailyCigarettes: secretSauce_1.pm25ToCigarettes(pm25[0].value),
        distanceToStation: station_1.distanceToStation(gps, pm25[0]),
        isAccurate: !station_1.isStationTooFar(gps, pm25[0])
      }
    };
  } else {
    throw new Error("Station " + normalized[0].location + " does not have PM2.5 measurings right now");
  }
}
/**
 * Helper function to fetch & normalize data for 1 provider.
 */


function fetchForProvider(gps, provider, options) {
  return __awaiter(this, void 0, void 0, function () {
    var data, normalized;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , provider.fetchByGps(gps, options)];

        case 1:
          data = _a.sent();
          normalized = provider.normalizeByGps(data);
          l("Got data from " + provider.id + ": " + JSON.stringify(normalized));
          return [2
          /*return*/
          , normalized];
      }
    });
  });
}
/**
 * Fetch data parallely from difference data sources, and return the first
 * response as an {@link Api} format.
 *
 * @param gps - The GPS coordinates to fetch data for
 */


function raceApiPromise(gps, options) {
  var now = new Date(); // Run these tasks parallely

  var tasks = [fetchForProvider(gps, promise_1.aqicn, options.aqicn).then(function (normalized) {
    return createApi(gps, normalized);
  }), fetchForProvider(gps, promise_1.openaq, __assign({
    dateFrom: date_fns_1.subHours(now, NORMALIZED_WITHIN_HOURS)
  }, options.openaq)).then(function (normalized) {
    return createApi(gps, normalized);
  })];
  return p_any_1["default"](tasks)["catch"](function (errors) {
    // Transform an AggregateError into a JS native Error
    var aggregateMessage = __spread(errors).map(function (_a, index) {
      var message = _a.message;
      return index + 1 + ". " + message;
    }).join('. ');

    throw new Error(aggregateMessage);
  });
}

exports.raceApiPromise = raceApiPromise;